import React from 'react';

export default function LogoLoader({ fullScreen = true }) {
  return (
    <div style={{
      minHeight: fullScreen ? '100vh' : '200px',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: '#0f172a', fontFamily: "'Segoe UI', sans-serif",
    }}>
      <style>{`
        @keyframes gs-spinRing {
          to { transform: rotate(360deg); }
        }
        @keyframes gs-pulseLogo {
          0%,100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(245,158,11,0.5); }
          50%      { transform: scale(1.07); box-shadow: 0 0 0 14px rgba(245,158,11,0); }
        }
        @keyframes gs-fadeText {
          0%,100% { opacity: 0.4; } 50% { opacity: 1; }
        }
      `}</style>
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{
          position: 'absolute',
          width: '130px', height: '130px',
          borderRadius: '50%',
          border: '3px solid transparent',
          borderTopColor: '#F59E0B',
          borderRightColor: '#D97706',
          animation: 'gs-spinRing 1s linear infinite',
        }} />
        <div style={{
          width: '110px', height: '110px',
          borderRadius: '50%', overflow: 'hidden',
          animation: 'gs-pulseLogo 1.6s ease-in-out infinite',
        }}>
          <img src="/logo.jpg" alt="Al Ameen"
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%', display: 'block' }} />
        </div>
      </div>
      <p style={{
        marginTop: '28px', color: '#F59E0B',
        fontSize: '14px', fontWeight: '600',
        letterSpacing: '1.5px', textTransform: 'uppercase',
        animation: 'gs-fadeText 1.6s ease-in-out infinite',
      }}>
        Al Ameen Gold &amp; Silver
      </p>
    </div>
  );
}
